import "./Form.css"

const Form = () => {
    return (
        <main>
            <div className="form_container">
                <h2>Form Information</h2>
                <form>
                    <div className="all">
                        <div className="one">
                            <p className="form_label">Full Name</p>
                            <input className="form_input" type="text" placeholder="Nour Ali" />
                        </div>
                        <div className="two">
                            <p className="form_label">Email</p>
                            <input className="form_input" type="email" placeholder="nourali@gmail.com" />
                        </div>
                    </div>
                    <div className="all">
                        <div className="one">
                            <p className="form_label">Number</p>
                            <input className="form_input" type="number" placeholder="0949376648" />
                        </div>
                        <div className="two">
                            <p className="form_label">Password</p>
                            <input className="form_input" type="password" placeholder="password" />
                        </div>
                    </div>
                    <p className="form_label">Address</p>
                    <input className="full_input" type="text" placeholder="Damas | Syria" />
                    <button className="form_btn">Save</button>
                </form>
            </div>
        </main>
    )
}

export default Form;